<div class="user-roles-container">
  <app-prime-ng-data-table
    [data]="roles()"
    [columns]="tableColumns()"
    [options]="tableOptions"
    [loading]="loading()"
    [totalRecords]="totalEntries()"
    [multiSelect]="false"
    [dataKey]="'roleId'"
    [tableId]="'user-roles'"
    [persistColumnWidths]="true"
    [selectedRows]="getSelectedRowsArray()"
    [textFilters]="textFilters"
    [filterOptions]="filterOptions"
    [moreActions]="moreActions"
    [itemLabel]="'Role'"
    [showToolbar]="false"
    [useSplitButton]="false"
    [rowDetailHref]="roleRowDetailHref"

    (event)="onTableEvent($event)"
    (lazyLoad)="handleManualLazyLoad($event)"
    (rowSelect)="onRowSelect($event)"
    (rowUnselect)="onRowUnselect($event)"
    (selectAll)="onSelectAll($event)"
    (rowClick)="onRowClick($event)"
    (rowExpand)="handleRowExpand($event)"
    #datatableComponent
  ></app-prime-ng-data-table>

  <!-- Delete Confirmation Modal -->
  <app-confirmation-modal
    [config]="deleteModalConfig"
    [isOpen]="isDeleteModalOpen"
    (confirm)="onDeleteConfirm($event)"
    (cancel)="onDeleteCancel($event)">
  </app-confirmation-modal>

  <!-- Role Reassignment Modal -->
      <app-role-reassignment-modal
      [isOpen]="showRoleReassignmentModal"
      [roleToDelete]="roleToDelete"
      [availableRoles]="availableRolesForReassignment"
      [isLoading]="isDeletingRole"
      (confirm)="onReassignmentConfirm($event)"
      (cancel)="onReassignmentCancel()"
      (close)="onReassignmentCancel()">
    </app-role-reassignment-modal>

</div>
